
import React from 'react';

interface ExamScoreProps {
  obtainedScore: number | undefined;
  maxScore: number | undefined;
  showPercentage?: boolean;
}

const ExamScore = ({ obtainedScore, maxScore, showPercentage = false }: ExamScoreProps) => {
  // Use safe values to prevent errors
  const safeObtained = Number(obtainedScore || 0);
  const safeMax = Number(maxScore || 0);
  
  // Calculate percentage only if needed
  const percentage = safeMax > 0 ? ((safeObtained / safeMax) * 100).toFixed(1) : '0.0';
  
  // Determine color based on score percentage
  const getScoreColor = () => {
    if (safeMax === 0) return 'text-gray-500';
    const ratio = safeObtained / safeMax;
    if (ratio >= 0.8) return 'text-green-600 font-semibold';
    if (ratio >= 0.6) return 'text-blue-600';
    if (ratio >= 0.4) return 'text-amber-600';
    return 'text-red-600';
  };
  
  return (
    <div className="flex items-center gap-2">
      <span className={`font-medium ${getScoreColor()}`}>
        {safeObtained.toFixed(1)}/{safeMax}
      </span>
      {showPercentage && safeMax > 0 && (
        <span className="text-xs text-muted-foreground">
          ({percentage}%)
        </span>
      )}
    </div>
  );
};

export default ExamScore;
